<app-page-header title="Organisationsdetaljer" icon="domain"></app-page-header>
<div [@fadeInOut] class="page-content">
  <mat-tab-group>
    <mat-tab label="Allmänt">
      <form #form="ngForm" [formGroup]="organizationForm" (ngSubmit)="save()" novalidate fxLayout="column" fxLayoutGap="1em" autocomplete="off">
        <mat-card appearance="outlined">
          <mat-card-content>
            <div class="flex-row flex-col-ltmd gap-col-1em">
              <mat-form-field class="flex-1">
                <mat-label>Namn</mat-label>
                <input matInput formControlName="name" required />
                @if (getFormControl('name').hasError('required')) {
                  <mat-error>Namn är obligatoriskt</mat-error>
                }
                @if (getFormControl('name').hasError('maxlength')) {
                  <mat-error>Namn får inte innehålla mer än 100 tecken</mat-error>
                }
              </mat-form-field>
              <div class="flex-1">
                <mat-checkbox formControlName="enabled">Aktiv</mat-checkbox>
              </div>
            </div>
            <div class="flex-row flex-col-ltmd gap-col-1em">
              <mat-form-field class="flex-1">
                <mat-label>Org.nr</mat-label>
                <input matInput formControlName="organizationNo" />
                @if (getFormControl('organizationNo').hasError('maxlength')) {
                  <mat-error>Org.nr. får inte innehålla mer än 20 tecken</mat-error>
                }
              </mat-form-field>
              <mat-form-field class="flex-1">
                <mat-label>Ägare</mat-label>
                <mat-select formControlName="ownedBy">
                  <mat-option>{{ 'globalTexts.ChooseInstruction' | translate }}</mat-option>
                  @for (entry of users$ | async; track entry) {
                    <mat-option [value]="entry.item1">
                      {{ entry.item2 }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
            <div class="flex-row flex-col-ltmd gap-col-1em">
              <mat-form-field class="flex-1">
                <mat-label>Region</mat-label>
                <mat-select formControlName="regionId" placeholder="">
                  <mat-option>{{ 'globalTexts.ChooseInstruction' | translate }}</mat-option>
                  @for (entry of regions$ | async; track entry) {
                    <mat-option [value]="entry.item1">
                      {{ entry.item2 }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <mat-form-field class="flex-1">
                <mat-label>Kontaktperson</mat-label>
                <input matInput formControlName="contactPerson" />
                @if (getFormControl('contactPerson').hasError('maxlength')) {
                  <mat-error>Kontaktperson får inte innehålla mer än 200 tecken</mat-error>
                }
              </mat-form-field>
            </div>
            <div class="flex-row flex-col-ltmd gap-col-1em">
              <mat-form-field class="flex-1">
                <mat-label>E-post</mat-label>
                <input matInput formControlName="email" />
                @if (getFormControl('email').hasError('maxlength')) {
                  <mat-error>E-post får inte innehålla mer än 255 tecken</mat-error>
                }
              </mat-form-field>
              <mat-form-field class="flex-1">
                <mat-label>Telefon</mat-label>
                <input matInput formControlName="phone" type="tel" />
              </mat-form-field>
            </div>
            @if (!isNew) {
              <div class="flex-row flex-col-ltmd gap-col-1em">
                <mat-form-field class="flex-1" [hidden]="isNew">
                  <mat-label>Skapad av</mat-label>
                  <input matInput [readonly]="true" value="{{ createdByName$ | async }}" />
                </mat-form-field>
                <mat-form-field class="flex-1">
                  <mat-label>Skapad</mat-label>
                  <input matInput formControlName="createdDate" [readonly]="true" />
                </mat-form-field>
              </div>
            }
            @if (!isNew) {
              <div class="flex-row flex-col-ltmd gap-col-1em">
                <mat-form-field class="flex-1">
                  <mat-label>Uppdaterad av</mat-label>
                  <input matInput [readonly]="true" value="{{ changedByName$ | async }}" />
                </mat-form-field>
                <mat-form-field class="flex-1">
                  <mat-label>Uppdaterad</mat-label>
                  <input matInput formControlName="updatedDate" [readonly]="true" />
                </mat-form-field>
              </div>
            }
            @if (!isNew) {
              <div class="flex-row flex-col-ltmd gap-col-1em">
                <mat-form-field class="flex-1">
                  <mat-label>Id</mat-label>
                  <input matInput formControlName="organizationId" [readonly]="true" />
                </mat-form-field>
              </div>
            }
          </mat-card-content>
          <mat-card-actions>
            <section class="button-container">
              @if (hasPermissionToChange()) {
                <button type="submit" mat-fab color="primary" title="{{'commands.Save' | translate }}"><mat-icon>done</mat-icon></button>
              }
              <button type="button" mat-fab (click)="cancel()" color="warn" title="{{'commands.Cancel' | translate }}"><mat-icon>arrow_back</mat-icon></button>
            </section>
          </mat-card-actions>
        </mat-card>
      </form>
    </mat-tab>
    @if (!isNew) {
      <mat-tab label="Verksamheter">
        <mat-card appearance="outlined">
          <mat-card-content>
            @if (!isNew) {
              <app-business-list [organizationId]="id" showTitle="false"></app-business-list>
            }
          </mat-card-content>
        </mat-card>
      </mat-tab>
    }
  </mat-tab-group>

</div>
